__webpack_require__.p = "/mino-portfolio/";